import axios from "axios";

// 查询评估列表
export async function getAssessListFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/evaluation/records?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}

// 查询消费记录列表
export async function getConsumptionListFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/orders/query?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}

// 获取车信盟报告链接
export async function getAccidentFun(params) {
    return new Promise((resolve, reject) => {
        let url = `/api/accident/${params.id}`;
        if (params?.thirdPartyName) {
            url += `?thirdPartyName=${params.thirdPartyName}`
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 手动生成评估报告图片
export async function generateAssessImageFun(id) {
    return new Promise((resolve, reject) => {
        axios.get(`/api/bms/evaluation/records/${id}/generate-image`).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject(res.data);
            }
        }).catch(err => {
            reject(err);
        })
    })
}